import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./_store/store";
import Loader from "./_components/common/Loader";

// Register Chart.js components early - must be before any chart components are imported
import "./_components/Reporting/Charts/chartjs.config";

// Styles
import "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // required for dropdowns
import 'react-datepicker/dist/react-datepicker.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <Loader />
      <App />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);
